import { UlmButton } from "@components/ulm/ulm-button";
import { Alert } from "@flat-ui";
import { useAppNavigation } from "@hooks/use-app-navigation";
import { Box } from "@mui-wrapper";

/**
 * Component to display an error message when email verification fails.
 * It provides a button to resend the verification email.
 */
export function EmailVerificationError(): JSX.Element {
  const { navigateToResendEmail } = useAppNavigation();

  return (
    <>
      <Alert
        title={"Email Verification Failed"}
        description={
          <>
            Your email address could not be verified.
            <Box component="div" sx={{ marginTop: "5px" }}>
              Note that verification links can only be used once.
              <br />
              You can also request a new verification email by clicking on the
              button below.
            </Box>
          </>
        }
        variant="error"
      />

      <UlmButton
        onClick={navigateToResendEmail}
        sx={{
          marginTop: "20px",
        }}
      >
        Resend Email
      </UlmButton>
    </>
  );
}
